import { ImageSource } from '../types';
import { isVideoUrl, isYouTubeUrl } from './mediaUtils';

/**
 * Transform a raw image URL to a CDN-optimized URL with width, format, and quality params.
 * Video and YouTube URLs are returned unchanged.
 */
export function getImageUrl(image: ImageSource, width?: number, height?: number): string {
  let url = image.url;

  if (isVideoUrl(url) || isYouTubeUrl(url)) {
    return url;
  }

  if (url.startsWith('https://beat-assets.s3.amazonaws.com/images/')) {
    url = url.replace(
      'https://beat-assets.s3.amazonaws.com/images/',
      'https://cdn.balloon-events.com/images/'
    );
  }
  const searchParams = new URLSearchParams();
  if (width) {
    searchParams.append('width', width.toFixed(0));
  } else if (height) {
    searchParams.append('height', height.toFixed(0));
  } else {
    searchParams.append('width', '400');
    searchParams.append('width', '600');
  }
  searchParams.append('format', 'webp');
  searchParams.append('quality', '60');
  if (searchParams.toString()) {
    url += '?' + searchParams.toString();
  }
  return url;
}

/**
 * Generate a srcset string for responsive images.
 */
export function getImageSrcset(image: ImageSource, baseWidth?: number): string {
  const base = baseWidth || 400;
  const srcset = [
    { width: base, resolution: '1x' },
    { width: base * 2, resolution: '2x' },
    { width: base * 3, resolution: '3x' },
  ]
    .map(
      ({ width, resolution }) => `${getImageUrl(image, width)} ${resolution}w`
    )
    .join(', ');

  return srcset;
}
